"use strict";

exports.__esModule = true;
exports.DeviceDataTableThumbnail = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Core = require("../../Core");
var _Measures = require("../../Measures");
var _class, _DeviceDataTableThumbnail;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Thumbnail for DeviceDataTableWidget.
 */
var DeviceDataTableThumbnail = exports.DeviceDataTableThumbnail = (0, _Core.withTranslator)(_class = (_DeviceDataTableThumbnail = /*#__PURE__*/function (_Component) {
  function DeviceDataTableThumbnail() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.now = Date.now();
    _this.renderRow = function (_ref) {
      var index = _ref.index,
        top = _ref.top,
        left = _ref.left,
        height = _ref.height;
      var columnWidths = _this.getColumnWidths();
      var body = [];
      var x = left;
      for (var i = 0; i < columnWidths.length; i++) {
        var width = columnWidths[i];
        body.push(/*#__PURE__*/_react["default"].createElement(_Measures.TextValue, {
          key: index + ":" + i,
          x: x,
          y: top,
          width: width,
          height: height,
          value: "0"
        }));
        x += width;
      }
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: index
      }, body);
    };
    return _this;
  }
  _inheritsLoose(DeviceDataTableThumbnail, _Component);
  var _proto = DeviceDataTableThumbnail.prototype;
  _proto.getColumnWidths = function getColumnWidths() {
    var width = this.props.width;
    return Array(9).fill(width / 9);
  };
  _proto.getColumnLabels = function getColumnLabels() {
    var translator = this.props.translator;
    var translate = translator.translate;
    return [translate("DeviceDataTableThumbnail.device", "Device"), translate("DeviceDataTableThumbnail.createdAt", "Created At"), translate("DeviceDataTable.createdBy", "Created By"), translate("DeviceDataTable.comment", "Comment")];
  };
  _proto.render = function render() {
    var _this$props = this.props,
      x = _this$props.x,
      y = _this$props.y,
      width = _this$props.width,
      height = _this$props.height;
    var itemHeight = 20;
    var availableHeight = height - itemHeight;
    var totalVisible = Math.ceil(availableHeight / itemHeight);
    var visible = [];
    var top = 0;
    for (var index = 0; index < totalVisible; index++) {
      visible.push(this.renderRow({
        index: index,
        top: top,
        left: 0,
        width: width,
        height: itemHeight
      }));
      top += itemHeight;
    }
    return /*#__PURE__*/_react["default"].createElement("svg", {
      x: x,
      y: y,
      width: width,
      height: height
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      x: 0,
      y: 0,
      width: width,
      height: height,
      fill: "#fff"
    }), /*#__PURE__*/_react["default"].createElement("svg", {
      width: width,
      height: itemHeight
    }, this.renderHeaders()), /*#__PURE__*/_react["default"].createElement("svg", {
      x: 0,
      y: itemHeight,
      width: width,
      height: availableHeight
    }, visible));
  };
  _proto.renderHeaders = function renderHeaders() {
    var height = 80;
    var columnWidths = this.getColumnWidths();
    var columnLabels = this.getColumnLabels();
    var headers = [];
    var x = 0;
    for (var index = 0; index < columnWidths.length; index++) {
      var width = columnWidths[index];
      headers.push(/*#__PURE__*/_react["default"].createElement(_Measures.TextValue, {
        key: String(index),
        x: x,
        y: 0,
        width: width,
        height: height,
        fontSize: 24,
        value: columnLabels[index]
      }));
      x += width;
    }
    return headers;
  };
  return DeviceDataTableThumbnail;
}(_react.Component), _DeviceDataTableThumbnail.defaultProps = {
  width: 1024,
  height: 768,
  translator: undefined
}, _DeviceDataTableThumbnail)) || _class;